import type { QueryFunction, QueryKey } from '@tanstack/react-query'

type WidenedQueryOptions<TData> = {
  queryFn?: QueryFunction<TData, QueryKey> | undefined
  queryKey: QueryKey
}

export function extendKey<TData, TKey extends readonly unknown[]>(
  options: { queryFn?: QueryFunction<TData, TKey> | undefined; queryKey: TKey },
  ...extras: readonly unknown[]
): WidenedQueryOptions<TData> {
  return {
    queryFn: options.queryFn as QueryFunction<TData, QueryKey> | undefined,
    queryKey: [...options.queryKey, ...extras],
  }
}
